/**
 * Ubah apa pun menjadi string yang aman dirender React.
 *
 * react-hot-toast merender argumennya sebagai React child. Body error NestJS
 * berbentuk objek, dan mengirimnya ke toast membuat React melempar
 * "Objects are not valid as a React child" yang lalu muncul sebagai
 * Unexpected Application Error di halaman.
 *
 * Bentuk `message` berbeda-beda tergantung validation pipe:
 *   string : "Laporan sudah difinalisasi."
 *   array  : ["field a wajib diisi", "field b wajib diisi"]
 *   objek  : { dataBahanB3Id: "dataBahanB3Id must be a UUID" }
 * Ketiganya diratakan jadi satu string di sini.
 */
export function flattenMessage(value) {
  if (typeof value === "string" && value.trim()) return value.trim();

  if (Array.isArray(value)) {
    return value.map(flattenMessage).filter(Boolean).join(", ") || null;
  }

  if (value && typeof value === "object") {
    return Object.values(value).map(flattenMessage).filter(Boolean).join(", ") || null;
  }

  return null;
}

export function getErrorMessage(error, fallback) {
  const body = error?.response?.data;

  for (const candidate of [body?.message, body?.error, error?.message]) {
    const flattened = flattenMessage(candidate);
    if (flattened) return flattened;
  }

  return fallback;
}

/**
 * Baca jawaban unggahan berkas dengan aman.
 *
 * Dua hal membuat `await res.json()` tidak cukup di jalur unggahan:
 *
 * 1. Bila ada proxy (nginx dan sejenisnya) di depan API, berkas yang lebih
 *    besar dari client_max_body_size ditolak oleh PROXY, bukan oleh aplikasi.
 *    Jawabannya HTML, bukan JSON, sehingga res.json() melempar dan pengguna
 *    hanya melihat "Unexpected token <" - tidak ada petunjuk bahwa masalahnya
 *    ukuran berkas.
 * 2. Penolakan multer karena melewati batas juga menjawab 413 tanpa message.
 *
 * Keduanya diterjemahkan jadi satu kalimat yang bisa ditindaklanjuti pengguna.
 */
export async function bacaJawabanUnggahan(res) {
  if (res.status === 413) {
    return {
      message:
        "Ukuran berkas melebihi batas yang diterima server. Perkecil berkasnya, atau hubungi pengelola aplikasi bila ukurannya sudah sesuai dengan yang tertulis pada formulir.",
    };
  }

  try {
    return await res.json();
  } catch (galat) {
    return { message: `Server menjawab ${res.status} tanpa keterangan yang bisa dibaca.` };
  }
}

export default getErrorMessage;
